var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBold(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    stroke: "black",
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6365 3.22018C13.601 4.18465 14.1428 5.49275 14.1428 6.85672C14.1428 8.2207 13.601 9.5288 12.6365 10.4933C11.672 11.4577 10.3639 11.9996 8.99997 11.9996H2.14282V5.14244C2.14282 3.24889 3.67785 1.71387 5.57139 1.71387H8.99997C10.3639 1.71387 11.672 2.2557 12.6365 3.22018Z",
    strokeWidth: 2.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2951 20.7794C15.2952 19.8149 15.8571 18.5067 15.8571 17.1429C15.8571 15.7789 15.2952 14.4708 14.2951 13.5063C13.2948 12.5418 11.9383 12 10.5238 12H2.14282V18.8571C2.14282 20.7507 3.67785 22.2857 5.57139 22.2857H10.5238C11.9383 22.2857 13.2948 21.7438 14.2951 20.7794Z",
    strokeWidth: 2.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBold);
export default __webpack_public_path__ + "static/media/bold.c57ecac5b4b10925e9d93aab260f8e92.svg";
export { ForwardRef as ReactComponent };